export default "__VITE_ASSET__jS77$$R6__"